import cn from 'classnames';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import React, { useMemo, useState } from 'react';

import { TextButton } from '@bibliocommons/base-buttons';
import { Dropdown, DropdownMenuItem } from '@bibliocommons/base-dropdown';
import { EllipsisVertical as IconEllipsisVertical } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Modal, ModalContent, ModalFooter, ModalHeader } from '@bibliocommons/modal';

import './ContextMenu.scss';

const ContextMenu = ({
  className,
  confirmDeleteModalHeading,
  confirmDeleteModalMessage,
  onDeleteClick,
  onEditClick
}) => {
  // TODO: useRef would probably be better here
  const { cofirmDeleteModalKey, deleteButtonKey, editButtonKey, expandButtonKey } = useMemo(() => {
    return {
      cofirmDeleteModalKey: uniqueId('ContextMenu_ConfirmDeleteModal_'),
      deleteButtonKey: uniqueId('ContextMenu_DeleteButton_'),
      editButtonKey: uniqueId('ContextMenu_EditButton_'),
      expandButtonKey: uniqueId('ContextMenu_ExpandButton')
    };
  }, []);

  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] = useState(false);

  const closeConfirmDeleteModal = () => {
    setIsConfirmDeleteModalOpen(false);
  };

  const handleConfirmDelete = () => {
    setIsConfirmDeleteModalOpen(false);
    onDeleteClick();
  };

  const handleDeleteClick = () => {
    setIsConfirmDeleteModalOpen(true);
  };

  if (!(onDeleteClick || onEditClick)) {
    return null;
  }
  return (
    <>
      <Modal handleClose={closeConfirmDeleteModal} key={cofirmDeleteModalKey} open={isConfirmDeleteModalOpen}>
        <ModalHeader title={confirmDeleteModalHeading} />
        <ModalContent>
          <p>{confirmDeleteModalMessage}</p>
        </ModalContent>
        <ModalFooter handlePrimaryAction={handleConfirmDelete} primaryActionButtonText={confirmDeleteModalHeading} />
      </Modal>
      <Dropdown
        className={cn('cp-admin-browse-home-context-menu', className)}
        renderTrigger={handleToggle => (
          <TextButton className="expander" dataKey={expandButtonKey} handleClick={handleToggle} type="button">
            <IconEllipsisVertical />
            <ScreenReaderMessage>Expand option</ScreenReaderMessage>
          </TextButton>
        )}
        dataKey={`Dropdown_${deleteButtonKey}`}
      >
        {onEditClick && (
          <DropdownMenuItem key={`DropdownItem_${editButtonKey}`}>
            <TextButton block dataKey={editButtonKey} handleClick={onEditClick} type="button">
              Edit
            </TextButton>
          </DropdownMenuItem>
        )}
        {onDeleteClick && (
          <DropdownMenuItem key={`DropdownItem_${deleteButtonKey}`}>
            <TextButton block dataKey={deleteButtonKey} handleClick={handleDeleteClick} type="button">
              Delete
            </TextButton>
          </DropdownMenuItem>
        )}
      </Dropdown>
    </>
  );
};

ContextMenu.defaultProps = {
  confirmDeleteModalHeading: 'Delete item',
  confirmDeleteModalMessage: 'Are you sure you want to delete this item?'
};

ContextMenu.propTypes = {
  className: PropTypes.string,
  confirmDeleteModalHeading: PropTypes.string,
  confirmDeleteModalMessage: PropTypes.string,
  onDeleteClick: PropTypes.func,
  onEditClick: PropTypes.func
};

export default ContextMenu;
